"use strict";

var _toConsumableArray = require("/codebuild/output/src1330877900/src/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/codebuild/output/src1330877900/src/node_modules/@babel/runtime/helpers/slicedToArray.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.sort.js");
var _react = _interopRequireWildcard(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _googleMaps = require("../../utils/googleMaps");
var _query = require("../../utils/query");
require("./JobList.css");
var _validators = require("../../utils/validators");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var autoComplete; // Job List Component
//      Props:
//          searchTargets -> ex ['title', 'city', 'state', 'reqNumber']
//          apiKey -> Google maps API key.
// 			indexes
//          options:
//              myLocationPlaceholderText
//              clearFieldIconTitle
//              searchFieldIconTitle
//              minLocationChangeTermCharacters
//              searchType
//              mapMarkerIconTitle
// 				buttonText
//

var JobList = function JobList(props) {
  var _props$options7, _props$option10, _props$options8, _props$options9, _props$options10, _props$options11, _props$options12, _props$options13, _props$options14, _props$options15, _props$options16, _props$options17, _props$options18;

  // States
  var _ref2 = (0, _react.useState)(''),
    _ref3 = _slicedToArray(_ref2, 2),
    searchTerm = _ref3[0],
    setSearchTerm = _ref3[1];
  var _ref4 = (0, _react.useState)([]),
    _ref5 = _slicedToArray(_ref4, 2),
    places = _ref5[0],
    setPlaces = _ref5[1];
  var _ref6 = (0, _react.useState)(''),
    _ref7 = _slicedToArray(_ref6, 2),
    searchTermText = _ref7[0],
    setSearchTermText = _ref7[1];
  var _ref8 = (0, _react.useState)([]),
    _ref9 = _slicedToArray(_ref8, 2),
    selectedStates = _ref9[0],
    setSelectedStates = _ref9[1];
  var _ref10 = (0, _react.useState)([]),
    _ref11 = _slicedToArray(_ref10, 2),
    selectedCities = _ref11[0],
    setSelectedCities = _ref11[1];
  var _ref12 = (0, _react.useState)([]),
    _ref13 = _slicedToArray(_ref12, 2),
    cities = _ref13[0],
    setCities = _ref13[1];
  var _ref14 = (0, _react.useState)([]),
    _ref15 = _slicedToArray(_ref14, 2),
    states = _ref15[0],
    setStates = _ref15[1];
  var _ref16 = (0, _react.useState)([]),
    _ref17 = _slicedToArray(_ref16, 2),
    displayedCities = _ref17[0],
    setDisplayedCities = _ref17[1];
  var _ref18 = (0, _react.useState)([]),
    _ref19 = _slicedToArray(_ref18, 2),
    selectedShiftTypes = _ref19[0],
    setSelectedShiftTypes = _ref19[1];
  var _ref20 = (0, _react.useState)([]),
    _ref21 = _slicedToArray(_ref20, 2),
    shiftTypes = _ref21[0],
    setShiftTypes = _ref21[1];
  var _ref22 = (0, _react.useState)([]),
    _ref23 = _slicedToArray(_ref22, 2),
    selectedCategories = _ref23[0],
    setSelectedCategories = _ref23[1];
  var _ref24 = (0, _react.useState)([]),
    _ref25 = _slicedToArray(_ref24, 2),
    categories = _ref25[0],
    setCategories = _ref25[1];
  var _ref26 = (0, _react.useState)(true),
    _ref27 = _slicedToArray(_ref26, 2),
    sortDirection = _ref27[0],
    setSortDirection = _ref27[1];
  var _ref28 = (0, _react.useState)(''),
    _ref29 = _slicedToArray(_ref28, 2),
    locationTerm = _ref29[0],
    setLocationTerm = _ref29[1]; //

  var _ref30 = (0, _react.useState)(''),
    _ref31 = _slicedToArray(_ref30, 2),
    locationTermText = _ref31[0],
    setLocationTermText = _ref31[1];
  var _ref32 = (0, _react.useState)([]),
    _ref33 = _slicedToArray(_ref32, 2),
    jobs = _ref33[0],
    setJobs = _ref33[1]; // All jobs.

  var _ref34 = (0, _react.useState)([]),
    _ref35 = _slicedToArray(_ref34, 2),
    displayedJobs = _ref35[0],
    setDisplayedJobs = _ref35[1]; // Filtered Jobs that are displayed.

  var _ref36 = (0, _react.useState)(false),
    _ref37 = _slicedToArray(_ref36, 2),
    disableLocationSearch = _ref37[0],
    setDisableLocationSearch = _ref37[1];
  var _ref38 = (0, _react.useState)(''),
    _ref39 = _slicedToArray(_ref38, 2),
    lat = _ref39[0],
    setLat = _ref39[1];
  var _ref40 = (0, _react.useState)(''),
    _ref41 = _slicedToArray(_ref40, 2),
    lng = _ref41[0],
    setLng = _ref41[1];
  var _ref42 = (0, _react.useState)(''),
    _ref43 = _slicedToArray(_ref42, 2),
    latTemp = _ref43[0],
    setLatTemp = _ref43[1];
  var _ref44 = (0, _react.useState)(''),
    _ref45 = _slicedToArray(_ref44, 2),
    lngTemp = _ref45[0],
    setLngTemp = _ref45[1];
  var _ref46 = (0, _react.useState)(10),
    _ref47 = _slicedToArray(_ref46, 2),
    range = _ref47[0],
    setRange = _ref47[1];
  var _ref48 = (0, _react.useState)(10),
    _ref49 = _slicedToArray(_ref48, 2),
    rangeTemp = _ref49[0],
    setRangeTemp = _ref49[1];
  var _ref50 = (0, _react.useState)('mi'),
    _ref51 = _slicedToArray(_ref50, 2),
    units = _ref51[0],
    setUnits = _ref51[1]; //Todo: Make a KM/Miles Switcher

  var _ref52 = (0, _react.useState)(1),
    _ref53 = _slicedToArray(_ref52, 2),
    page = _ref53[0],
    setPage = _ref53[1];
  var _ref54 = (0, _react.useState)(25),
    _ref55 = _slicedToArray(_ref54, 2),
    rowsPerPage = _ref55[0],
    setRowsPerPage = _ref55[1];
  var _ref56 = (0, _react.useState)(false),
    _ref57 = _slicedToArray(_ref56, 2),
    locationResultSelected = _ref57[0],
    setLocationResultSelected = _ref57[1];
  var _ref58 = (0, _react.useState)('No Results Found.'),
    _ref59 = _slicedToArray(_ref58, 2),
    noResultsMessage = _ref59[0],
    setNoResultsMessage = _ref59[1]; // Variables

  var data = props.data;
  var indexes = props.indexes || [{
    name: 'title',
    factor: 4
  }, {
    name: 'description',
    factor: 1
  }, {
    name: 'city',
    factor: 2
  }, {
    name: 'state',
    factor: 2
  }, {
    name: 'reqNumber',
    factor: 6
  }, {
    name: 'category',
    factor: 3
  }]; // Hooks

  (0, _react.useEffect)(function () {
    var _data$allSitePage;

    // Extract jobs from GraphQL Query
    var tempJobs = [];
    var allJobs = data === null || data === void 0 ? void 0 : (_data$allSitePage = data.allSitePage) === null || _data$allSitePage === void 0 ? void 0 : _data$allSitePage.edges;
    var tempShifts = _toConsumableArray(shiftTypes);
    var tempCities = [];
    var tempStates = [];
    var tempCategories = [];
    var _loop = function _loop() {
      if ((_allJobs$job = allJobs[job]) !== null && _allJobs$job !== void 0 && (_allJobs$job$node = _allJobs$job.node) !== null && _allJobs$job$node !== void 0 && _allJobs$job$node.pageContext) {
        if ((_allJobs$job2 = allJobs[job]) !== null && _allJobs$job2 !== void 0 && (_allJobs$job2$node = _allJobs$job2.node) !== null && _allJobs$job2$node !== void 0 && (_allJobs$job2$node$pa = _allJobs$job2$node.pageContext) !== null && _allJobs$job2$node$pa !== void 0 && _allJobs$job2$node$pa.title) {
          var fullTime = String((_allJobs$job3 = allJobs[job]) === null || _allJobs$job3 === void 0 ? void 0 : (_allJobs$job3$node = _allJobs$job3.node) === null || _allJobs$job3$node === void 0 ? void 0 : (_allJobs$job3$node$pa = _allJobs$job3$node.pageContext) === null || _allJobs$job3$node$pa === void 0 ? void 0 : _allJobs$job3$node$pa.fullTime);
          if (fullTime && fullTime !== 'n/a' && fullTime !== 'undefined') {
            if (!tempShifts.some(function (e) {
              return e.key === fullTime;
            })) {
              tempShifts.push({
                key: fullTime,
                text: fullTime,
                value: fullTime
              });
            }
          }
          var category = String((_allJobs$job4 = allJobs[job]) === null || _allJobs$job4 === void 0 ? void 0 : (_allJobs$job4$node = _allJobs$job4.node) === null || _allJobs$job4$node === void 0 ? void 0 : (_allJobs$job4$node$pa = _allJobs$job4$node.pageContext) === null || _allJobs$job4$node$pa === void 0 ? void 0 : _allJobs$job4$node$pa.category);
          if (category && category !== 'n/a' && category !== 'undefined') {
            if (!tempCategories.some(function (e) {
              return e.key === category;
            })) {
              tempCategories.push({
                key: category,
                text: category,
                value: category
              });
            }
          }
          var city = (_allJobs$job5 = allJobs[job]) === null || _allJobs$job5 === void 0 ? void 0 : (_allJobs$job5$node = _allJobs$job5.node) === null || _allJobs$job5$node === void 0 ? void 0 : (_allJobs$job5$node$pa = _allJobs$job5$node.pageContext) === null || _allJobs$job5$node$pa === void 0 ? void 0 : _allJobs$job5$node$pa.city;
          var state = (_allJobs$job6 = allJobs[job]) === null || _allJobs$job6 === void 0 ? void 0 : (_allJobs$job6$node = _allJobs$job6.node) === null || _allJobs$job6$node === void 0 ? void 0 : (_allJobs$job6$node$pa = _allJobs$job6$node.pageContext) === null || _allJobs$job6$node$pa === void 0 ? void 0 : _allJobs$job6$node$pa.state;
          var fullStateName = (_allJobs$job7 = allJobs[job]) === null || _allJobs$job7 === void 0 ? void 0 : (_allJobs$job7$node = _allJobs$job7.node) === null || _allJobs$job7$node === void 0 ? void 0 : (_allJobs$job7$node$pa = _allJobs$job7$node.pageContext) === null || _allJobs$job7$node$pa === void 0 ? void 0 : _allJobs$job7$node$pa.fullStateName;
          if (city && city !== 'n/a' && state && state !== 'n/a') {
            if (!tempCities.some(function (e) {
              return e.key === city;
            })) {
              tempCities.push({
                key: city,
                text: "".concat(city, ", ").concat(state),
                value: city,
                state: state
              });
            }
            if (!tempStates.some(function (e) {
              return e.key === state;
            })) {
              tempStates.push({
                key: state,
                text: "".concat(fullStateName ? fullStateName : state),
                value: state,
                state: state
              });
            }
          }
          tempJobs.push((_allJobs$job8 = allJobs[job]) === null || _allJobs$job8 === void 0 ? void 0 : (_allJobs$job8$node = _allJobs$job8.node) === null || _allJobs$job8$node === void 0 ? void 0 : _allJobs$job8$node.pageContext);
        }
      }
    };
    for (var job in allJobs) {
      var _allJobs$job, _allJobs$job$node, _allJobs$job2, _allJobs$job2$node, _allJobs$job2$node$pa, _allJobs$job3, _allJobs$job3$node, _allJobs$job3$node$pa, _allJobs$job4, _allJobs$job4$node, _allJobs$job4$node$pa, _allJobs$job5, _allJobs$job5$node, _allJobs$job5$node$pa, _allJobs$job6, _allJobs$job6$node, _allJobs$job6$node$pa, _allJobs$job7, _allJobs$job7$node, _allJobs$job7$node$pa, _allJobs$job8, _allJobs$job8$node;
      _loop();
    }
    setShiftTypes(tempShifts);
    setCities(tempCities);
    setDisplayedCities(tempCities);
    setStates(tempStates);
    setCategories(tempCategories); // Set the jobs.

    setJobs(tempJobs);
    setDisplayedJobs(tempJobs);
  }, [data]);
  (0, _react.useEffect)(function () {
    // Add google API in head.
    (0, _googleMaps.insertGoogleMapAPIScript)("https://maps.googleapis.com/maps/api/js?key=".concat(props.apiKey, "&libraries=places&callback=Function.prototype"), function () {
      autoComplete = new window.google.maps.places.AutocompleteService();
    });
  }, [props.apiKey]);
  (0, _react.useEffect)(function () {
    // Get search parameters from URL.
    var url = new URL(window.location.href);
    var term = url.searchParams.get('term');
    var latParam = url.searchParams.get('a');
    var stateParam = url.searchParams.get('state');
    var lngParam = url.searchParams.get('b');
    var o = url.searchParams.get('o');
    var loc = url.searchParams.get('loc');
    if (stateParam) {
      setSelectedStates([stateParam]);
    }
    if (term) {
      var _props$option;
      setSearchTerm(term);
      setSearchTermText(term);
      setSearchTermIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "close",
        onClick: handleClearSearchTermClick,
        title: (props === null || props === void 0 ? void 0 : (_props$option = props.option) === null || _props$option === void 0 ? void 0 : _props$option.clearFieldIconTitle) || 'Clear field.',
        link: true
      }));
    }
    if (latParam && lngParam) {
      setLat(latParam);
      setLng(lngParam); // If using user location from browser.

      if (o === 'uloc') {
        var _props$options, _props$options2, _props$option2;
        setLocationTerm((props === null || props === void 0 ? void 0 : (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.myLocationPlaceholderText) || 'My Location');
        setLocationTermText((props === null || props === void 0 ? void 0 : (_props$options2 = props.options) === null || _props$options2 === void 0 ? void 0 : _props$options2.myLocationPlaceholderText) || 'My Location');
        setDisableLocationSearch(true);
        setDisableLocationSearch(true);
        setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: "close",
          onClick: handleClearMyLocationTermClick,
          title: (props === null || props === void 0 ? void 0 : (_props$option2 = props.option) === null || _props$option2 === void 0 ? void 0 : _props$option2.clearFieldIconTitle) || 'Clear field',
          link: true
        }));
      } else if (o === 'gloc' && loc) {
        var _props$option3;

        // If using Google maps location.
        setLocationTerm(loc);
        setLocationTermText(loc);
        setDisableLocationSearch(true);
        setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: "close",
          onClick: handleClearMyLocationTermClick,
          title: (props === null || props === void 0 ? void 0 : (_props$option3 = props.option) === null || _props$option3 === void 0 ? void 0 : _props$option3.clearFieldIconTitle) || 'Clear field',
          link: true
        }));
        var retrievedPLaces = localStorage.getItem('places');
        if (retrievedPLaces) {
          setPlaces(JSON.parse(retrievedPLaces));
        }
      }
    }
  }, []);
  (0, _react.useEffect)(function () {
    setPage(1); // Query jobs that match the selected filters and terms.

    var queriedJobs = (0, _query.queryJobs)(jobs, searchTerm, lat, lng, range, indexes, units, selectedStates, selectedShiftTypes, selectedCities, selectedCategories);
    setDisplayedJobs(queriedJobs);
  }, [searchTerm, lat, lng, range, units, selectedStates, selectedShiftTypes, jobs, selectedCities, selectedCategories]);
  (0, _react.useEffect)(function () {
    var tempCities = [];
    selectedStates.map(function (state) {
      cities.map(function (city) {
        if ((city === null || city === void 0 ? void 0 : city.state) === state) {
          tempCities.push(city);
        }
      });
    });
    setDisplayedCities(tempCities);
  }, [selectedStates]);
  var handleClearSearchTermClick = function handleClearSearchTermClick() {
    setSearchTerm('');
    setSearchTermText('');
    setSearchTermIcon( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null));
  };
  var handleSearchTermChange = function handleSearchTermChange(e) {
    var value = e.target.value;
    setSearchTermText(value);
    if (value.length > 0) {
      var _props$option4;
      setSearchTermIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "close",
        onClick: handleClearSearchTermClick,
        title: (props === null || props === void 0 ? void 0 : (_props$option4 = props.option) === null || _props$option4 === void 0 ? void 0 : _props$option4.clearFieldIconTitle) || 'Clear field.',
        link: true
      }));
    } else {
      var _props$option5;
      setSearchTermIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "search",
        title: (props === null || props === void 0 ? void 0 : (_props$option5 = props.option) === null || _props$option5 === void 0 ? void 0 : _props$option5.searchFieldIconTitle) || 'Search.'
      }));
    }
  };
  var onStateDropdownChangeHandler = function onStateDropdownChangeHandler(e, data) {
    setSelectedStates(data.value);
    if (data.value.length === 0) {
      setSelectedCities([]);
    }
  };
  var onCitiesDropdownChangeHandler = function onCitiesDropdownChangeHandler(e, data) {
    setSelectedCities(data.value);
  };
  var onShiftTypeDropdownChangeHandler = function onShiftTypeDropdownChangeHandler(e, data) {
    setSelectedShiftTypes(data.value);
  };
  var onCategoriesDropdownChangeHandler = function onCategoriesDropdownChangeHandler(e, data) {
    setSelectedCategories(data.value);
  };
  var handleLocationTermChange = function handleLocationTermChange(e) {
    var _props$options3;
    setLocationTermText(e.target.value);
    if (e.target.value.length > (props === null || props === void 0 ? void 0 : (_props$options3 = props.options) === null || _props$options3 === void 0 ? void 0 : _props$options3.minLocationChangeTermCharacters) || 3) {
      try {
        var _props$option6, _props$option7;
        autoComplete.getPlacePredictions({
          input: e.target.value,
          types: (props === null || props === void 0 ? void 0 : (_props$option6 = props.option) === null || _props$option6 === void 0 ? void 0 : _props$option6.searchType) || ['(cities)'],
          componentRestrictions: {
            country: (props === null || props === void 0 ? void 0 : (_props$option7 = props.option) === null || _props$option7 === void 0 ? void 0 : _props$option7.country) || 'us'
          }
        }, function (places) {
          for (var place in places) {
            places[place].title = places[place].description;
            places[place].description = '';
          }
          setPlaces(places);
        }).catch(function (e) {
          console.log('Geocode error: ', e);
        });
      } catch (e) {
        console.log('Geocode error: ', e);
        setNoResultsMessage('Geocode Error.');
      }
    } else {
      setPlaces([]);
    }
    if (e.target.value.length > 0) {
      var _props$option8;
      setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "close",
        onClick: handleClearMyLocationTermClick,
        title: (props === null || props === void 0 ? void 0 : (_props$option8 = props.option) === null || _props$option8 === void 0 ? void 0 : _props$option8.clearFieldIconTitle) || 'Clear field.',
        link: true
      }));
    } else {
      var _props$options4;
      setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "map marker alternate",
        onClick: handleLocateMeClick,
        title: (props === null || props === void 0 ? void 0 : (_props$options4 = props.options) === null || _props$options4 === void 0 ? void 0 : _props$options4.mapMarkerIconTitle) || 'Use my location',
        link: true
      }));
    }
  };
  var handleSortChange = function handleSortChange() {
    setSortDirection(!sortDirection);
  };
  var SortDescAsc = function SortDescAsc() {
    return sortDirection ? /*#__PURE__*/_react.default.createElement("svg", {
      "aria-sort": 'ascending',
      xmlns: "http://www.w3.org/2000/svg",
      onClick: handleSortChange,
      style: {
        width: 20,
        cursor: 'pointer'
      },
      viewBox: "0 0 24 24",
      fill: "currentColor",
      className: "w-6 h-6"
    }, /*#__PURE__*/_react.default.createElement("path", {
      fillRule: "evenodd",
      d: "M2.25 4.5A.75.75 0 013 3.75h14.25a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75zm14.47 3.97a.75.75 0 011.06 0l3.75 3.75a.75.75 0 11-1.06 1.06L18 10.81V21a.75.75 0 01-1.5 0V10.81l-2.47 2.47a.75.75 0 11-1.06-1.06l3.75-3.75zM2.25 9A.75.75 0 013 8.25h9.75a.75.75 0 010 1.5H3A.75.75 0 012.25 9zm0 4.5a.75.75 0 01.75-.75h5.25a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75z",
      clipRule: "evenodd"
    })) : /*#__PURE__*/_react.default.createElement("svg", {
      "aria-sort": 'descending',
      style: {
        width: 20,
        cursor: 'pointer'
      },
      onClick: handleSortChange,
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor",
      className: "w-6 h-6"
    }, /*#__PURE__*/_react.default.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0l-3.75-3.75M17.25 21L21 17.25"
    }));
  };
  var handleRangeChange = function handleRangeChange(e, data) {
    setRangeTemp(data.value);
  };
  var handleRowsPerPageChange = function handleRowsPerPageChange(e, data) {
    setRowsPerPage(data.value);
  };
  var handleResultSelect = function handleResultSelect(e, data) {
    setLocationTermText(data.result.title);
    setLocationResultSelected(true);
    setDisableLocationSearch(true);
    var geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({
      placeId: data.result.place_id
    }, function (res, status) {
      if (status === 'OK') {
        var _res$, _res$$geometry, _res$$geometry$locati, _res$2, _res$2$geometry, _res$2$geometry$locat;
        setLatTemp((_res$ = res[0]) === null || _res$ === void 0 ? void 0 : (_res$$geometry = _res$.geometry) === null || _res$$geometry === void 0 ? void 0 : (_res$$geometry$locati = _res$$geometry.location) === null || _res$$geometry$locati === void 0 ? void 0 : _res$$geometry$locati.lat());
        setLngTemp((_res$2 = res[0]) === null || _res$2 === void 0 ? void 0 : (_res$2$geometry = _res$2.geometry) === null || _res$2$geometry === void 0 ? void 0 : (_res$2$geometry$locat = _res$2$geometry.location) === null || _res$2$geometry$locat === void 0 ? void 0 : _res$2$geometry$locat.lng());
      }
    });
  };
  var handleClearMyLocationTermClick = function handleClearMyLocationTermClick() {
    var _props$options5;
    setLocationTerm('');
    setLocationTermText('');
    setLocationResultSelected(false);
    setDisableLocationSearch(false);
    setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
      name: "map marker alternate",
      onClick: handleLocateMeClick,
      title: (props === null || props === void 0 ? void 0 : (_props$options5 = props.options) === null || _props$options5 === void 0 ? void 0 : _props$options5.mapMarkerIconTitle) || 'Use my location',
      link: true
    }));
    setLat('');
    setLng('');
    setLatTemp('');
    setLngTemp('');
  };
  var handlePaginationChange = function handlePaginationChange(e, _ref) {
    var activePage = _ref.activePage;
    setPage(activePage);
  };
  var handleLocateMeClick = function handleLocateMeClick(e) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function setCoordinates(position) {
        var _props$options6, _props$option9;
        setLat(position.coords.latitude.toString());
        setLng(position.coords.longitude.toString());
        setLocationTermText((props === null || props === void 0 ? void 0 : (_props$options6 = props.options) === null || _props$options6 === void 0 ? void 0 : _props$options6.myLocationPlaceholderText) || 'My Location');
        setDisableLocationSearch(true);
        setLocationIcon( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
          name: "close",
          onClick: handleClearMyLocationTermClick,
          title: (props === null || props === void 0 ? void 0 : (_props$option9 = props.option) === null || _props$option9 === void 0 ? void 0 : _props$option9.clearFieldIconTitle) || 'Clear field',
          link: true
        }));
      }, function (e) {});
    }
  };
  var _ref60 = (0, _react.useState)( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
      name: "map marker alternate",
      onClick: handleLocateMeClick,
      title: (props === null || props === void 0 ? void 0 : (_props$options7 = props.options) === null || _props$options7 === void 0 ? void 0 : _props$options7.mapMarkerIconTitle) || 'Use my location',
      link: true
    })),
    _ref61 = _slicedToArray(_ref60, 2),
    locationIcon = _ref61[0],
    setLocationIcon = _ref61[1];
  var _ref62 = (0, _react.useState)( /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
      name: "search",
      title: (props === null || props === void 0 ? void 0 : (_props$option10 = props.option) === null || _props$option10 === void 0 ? void 0 : _props$option10.clearFieldIconTitle) || 'Search.'
    })),
    _ref63 = _slicedToArray(_ref62, 2),
    searchTermIcon = _ref63[0],
    setSearchTermIcon = _ref63[1];
  var rangeOptions = [{
    key: 1,
    text: '1 Mile',
    value: 1
  }, {
    key: 10,
    text: '10 Miles',
    value: 10
  }, {
    key: 25,
    text: '25 Miles',
    value: 25
  }, {
    key: 50,
    text: '50 Miles',
    value: 50
  }, {
    key: 100,
    text: '100 Miles',
    value: 100
  }, {
    key: 500,
    text: '500+ Miles',
    value: 1000000000
  }];
  var rowsPerPageOptions = [{
    key: 10,
    text: '10',
    value: 10
  }, {
    key: 25,
    text: '25',
    value: 25
  }, {
    key: 50,
    text: '50',
    value: 50
  }, {
    key: 100,
    text: '100',
    value: 100
  }, {
    key: 250,
    text: '250',
    value: 250
  }, {
    key: 'All',
    text: 'All',
    value: 1021231231330
  }];
  function descendingComparator(a, b, orderBy) {
    if (orderBy === 'distance') {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
    } else if (orderBy === 'weight') {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
    } else {
      if (Date.parse(b[orderBy]) < Date.parse(a[orderBy])) {
        return -1;
      }
      if (Date.parse(b[orderBy]) > Date.parse(a[orderBy])) {
        return 1;
      }
    }
    return 0;
  }
  function getComparator(order, orderBy) {
    return order === 'desc' ? function (a, b) {
      return descendingComparator(a, b, orderBy);
    } : function (a, b) {
      return -descendingComparator(a, b, orderBy);
    };
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (props === null || props === void 0 ? void 0 : (_props$options8 = props.options) === null || _props$options8 === void 0 ? void 0 : _props$options8.jobListClassNames) || ''
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (props === null || props === void 0 ? void 0 : (_props$options9 = props.options) === null || _props$options9 === void 0 ? void 0 : _props$options9.searchBarWrapperClassNames) || ''
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Container, {
    as: 'form',
    style: {
      display: 'flex'
    },
    className: (props === null || props === void 0 ? void 0 : (_props$options10 = props.options) === null || _props$options10 === void 0 ? void 0 : _props$options10.searchBarClassNames) || '',
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      setSearchTerm(searchTermText);
      setLat(latTemp); // setSortDirection(false);

      setRange(rangeTemp);
      setLng(lngTemp);
      window.history.replaceState(null, null, '?term=' + searchTermText);
    }
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Search, {
    showNoResults: true,
    noResultsMessage: '',
    onSearchChange: handleSearchTermChange,
    className: (props === null || props === void 0 ? void 0 : (_props$options11 = props.options) === null || _props$options11 === void 0 ? void 0 : _props$options11.searchTermClassNames) || '',
    icon: searchTermIcon,
    minCharacters: 32143124123412,
    name: "search",
    id: "search_field",
    value: searchTermText,
    placeholder: 'Job Title, Keywords, Req ID'
  }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Search, {
    results: places,
    onSearchChange: handleLocationTermChange,
    onResultSelect: handleResultSelect,
    id: 'location_field',
    className: (props === null || props === void 0 ? void 0 : (_props$options12 = props.options) === null || _props$options12 === void 0 ? void 0 : _props$options12.formLocationTermClassNames) || '',
    minCharacters: (props === null || props === void 0 ? void 0 : (_props$options13 = props.options) === null || _props$options13 === void 0 ? void 0 : _props$options13.minLocationTermCharacters) || 4,
    icon: locationIcon,
    noResultsMessage: noResultsMessage,
    label: '',
    name: 'location',
    value: locationTermText,
    disabled: disableLocationSearch,
    placeholder: 'Location'
  }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
    placeholder: "Miles",
    defaultValue: 10,
    onChange: handleRangeChange,
    value: rangeTemp,
    selection: true,
    options: rangeOptions
  }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
    className: '',
    type: 'submit'
  }, "Search"))), /*#__PURE__*/_react.default.createElement("div", {
    className: (props === null || props === void 0 ? void 0 : (_props$options14 = props.options) === null || _props$options14 === void 0 ? void 0 : _props$options14.jobTableWrapperClassNames) || ''
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Container, {
    className: (props === null || props === void 0 ? void 0 : (_props$options15 = props.options) === null || _props$options15 === void 0 ? void 0 : _props$options15.jobResultsTitleClassNames) || ''
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'search-results-text'
  }, (props === null || props === void 0 ? void 0 : props.searchResultsText) || 'Search Results', ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: 'location-results-text'
  }, locationTerm || lat ? " - ".concat(locationTermText) : null))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Container, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    "job-filters": true,
    className: 'jobFilters ' + (props === null || props === void 0 ? void 0 : (_props$options16 = props.options) === null || _props$options16 === void 0 ? void 0 : _props$options16.filtersClassNames) || ''
  }, !(props !== null && props !== void 0 && props.hideFilters) ? /*#__PURE__*/_react.default.createElement("div", {
    className: 'filterWrapper',
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      padding: '10px 30px 10px 0px'
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (props === null || props === void 0 ? void 0 : (_props$options17 = props.options) === null || _props$options17 === void 0 ? void 0 : _props$options17.filtersTextClassName) || ''
  }, (props === null || props === void 0 ? void 0 : props.filtersTextFilters) || 'Filters', ":", ' '), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
    style: {
      width: '100%'
    },
    onChange: onStateDropdownChangeHandler,
    value: selectedStates,
    placeholder: "State",
    fluid: true,
    clearable: true,
    multiple: true,
    search: true,
    selection: true,
    options: states
  }), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
    style: {
      width: '100%'
    },
    onChange: onCitiesDropdownChangeHandler,
    value: selectedCities,
    placeholder: "City",
    fluid: true,
    clearable: true,
    multiple: true,
    disabled: selectedStates.length === 0 || displayedJobs.length === 0,
    search: true,
    selection: true,
    options: displayedCities
  }), categories.length > 0 ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
    onChange: onCategoriesDropdownChangeHandler,
    value: selectedCategories,
    placeholder: "Category",
    fluid: true,
    clearable: true,
    search: true,
    style: {
      width: '100%'
    },
    selection: true,
    multiple: true,
    options: categories
  }) : null, shiftTypes.length > 0 ? /*#__PURE__*/_react.default.createElement(_semanticUiReact.Dropdown, {
    onChange: onShiftTypeDropdownChangeHandler,
    value: selectedShiftTypes,
    placeholder: "Shift",
    fluid: true,
    clearable: true,
    search: true,
    style: {
      width: '100%'
    },
    selection: true,
    multiple: true,
    options: shiftTypes
  }) : null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: 'jobList ' + (props === null || props === void 0 ? void 0 : (_props$options18 = props.options) === null || _props$options18 === void 0 ? void 0 : _props$options18.jobListClassNames) || ''
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: -30,
      marginBottom: -20
    }
  }, /*#__PURE__*/_react.default.createElement("span", null, "Jobs: ", displayedJobs.length), /*#__PURE__*/_react.default.createElement(SortDescAsc, null)), displayedJobs.length === 0 ? /*#__PURE__*/_react.default.createElement("h3", null, "No Results Found.") : '', displayedJobs.sort(getComparator(sortDirection ? 'desc' : 'asc', (props === null || props === void 0 ? void 0 : props.orderByKey) || 'startDate')).slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage).map(function (job) {
    var _props$options19;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'job'
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: 'desc'
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: job.jobPath,
      target: props.targetBlank ? '_blank' : null
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: 'position'
    }, job.title), /*#__PURE__*/_react.default.createElement("br", null), job.fullTime && job.fullTime !== 'n/a' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: 'shift'
    }, job.fullTime), job.city === '.' || !job.city || job.city === 'n/a' ? null : /*#__PURE__*/_react.default.createElement("span", {
      className: 'tiret'
    }, ' ', "-", ' '), ' ') : null, /*#__PURE__*/_react.default.createElement("span", {
      className: 'location'
    }, job.city === '.' || !job.city || job.city === 'n/a' ? null : "".concat(job.city, ","), ' ', job.state)), job.startDate !== 'n/a' ? /*#__PURE__*/_react.default.createElement("span", {
      className: 'posted'
    }, /*#__PURE__*/_react.default.createElement("b", null, "Posted:", ' ', /*#__PURE__*/_react.default.createElement("span", {
      className: 'date'
    }, new Date(Date.parse(job.startDate)).toDateString()))) : null), /*#__PURE__*/_react.default.createElement("div", {
      className: 'apply'
    }, /*#__PURE__*/_react.default.createElement("ul", null, props.applyNowValues ? props.applyNowValues.map(function (value) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, value.hideLabel ? null : /*#__PURE__*/_react.default.createElement("span", {
        className: "".concat(value.value.toLowerCase(), "-label")
      }, value.text), /*#__PURE__*/_react.default.createElement("li", {
        className: "".concat(value.value.toLowerCase(), "-value")
      }, job[value.value]));
    }) : null), /*#__PURE__*/_react.default.createElement("a", {
      href: job.jobPath,
      target: props.targetBlank ? '_blank' : null
    }, /*#__PURE__*/_react.default.createElement("button", null, (props === null || props === void 0 ? void 0 : (_props$options19 = props.options) === null || _props$options19 === void 0 ? void 0 : _props$options19.buttonText) || 'APPLY NOW'))));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: 'pagination'
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Pagination, {
    activePage: page,
    onPageChange: handlePaginationChange,
    totalPages: rowsPerPage >= displayedJobs.length ? 1 : Math.ceil(displayedJobs.length / rowsPerPage)
  }))))));
};
var _default = JobList;
exports.default = _default;